import { render, staticRenderFns } from "./FooterPrismic.vue?vue&type=template&id=6d2f1c1a&scoped=true&"
import script from "./FooterPrismic.vue?vue&type=script&lang=js&"
export * from "./FooterPrismic.vue?vue&type=script&lang=js&"
import style0 from "./FooterPrismic.vue?vue&type=style&index=0&id=6d2f1c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f1c1a",
  null
  
)

export default component.exports